<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.PIPELINE"
  [dataService]="salesOpportunitiesService"
  [formControl]="pipelineControl"
  [supportDataPassing]="false"
  [isRequired]="required"
  [multiple]="false"
  (finishedInitialLoading)="finishedLoading()"
></automata-automation-replacement-chips>

<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STAGE"
  *ngIf="stageOptions.size > 0"
  [dataService]="stageOptionsDataService"
  [formControl]="stageProbabilityControl"
  [supportDataPassing]="false"
  [isRequired]="required"
  [multiple]="false"
></automata-automation-replacement-chips>
